import { useEffect } from "react";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/lucario.css";
import "codemirror/mode/javascript/javascript.js";
import { useSelector, useDispatch } from "react-redux";
import { Controlled as CodeMirror } from "react-codemirror2";
import { updateEditorValue } from "../../actions/editor";
import "./index.css";
import { useRouteMatch } from "react-router-dom";
import getProblemForCurrentURL from "../../hooks/problem";

const Editor = () => {
  const dispatch = useDispatch();
  const { params } = useRouteMatch();
  const { problemUrl } = params;
  const { starter } = getProblemForCurrentURL(params);

  const value = useSelector((state) => {
    return state.editor[problemUrl] || "";
  });

  useEffect(() => {
    if (!value) {
      dispatch(updateEditorValue({ problemId: problemUrl, value: starter }));
    }
  }, [value]);

  return (
    <CodeMirror
      value={value}
      options={{
        mode: "javascript",
        theme: "lucario",
        lineNumbers: true,
      }}
      onBeforeChange={(editor, data, value) => {
        dispatch(updateEditorValue({ problemId: problemUrl, value }));
      }}
      //   onChange={(editor, data, value) => {
      //     console.log(value);
      //     dispatch(updateEditorValue(value));
      //   }}
    />
  );
};

export default Editor;
